import {Component, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Router} from '@angular/router';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {MetaService} from '../../../services/meta/meta.service';
import {LangSrcService} from '../../../services/lang-src/lang-src.service';
import {AssessmentService} from '../../../services/assessment/assessment.service';
import {AudioService} from '../../../services/audio/audio.service';
import {SpinnerComponent} from '../../../components/spinner/spinner.component';
import {ProgressCircleComponent} from '../../../components/progress/progress-circle/progress-circle.component';

@Component({
  selector: 'app-assessment-result',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    SpinnerComponent,
    ProgressCircleComponent
  ],
  templateUrl: './assessment-result.component.html',
  styleUrls: ['./assessment-result.component.scss']
})
export class AssessmentResultComponent implements OnInit {

  loading = true;
  result: any;

  constructor(
    private metaSrv: MetaService,
    private translate: TranslateService,
    public langSrcSrv: LangSrcService,
    private router: Router,
    private assessmentSrv: AssessmentService,
    public audioSrv: AudioService
  ) {
  }

  trackByIndex(index: number) { return index; }

  async ngOnInit() {
    this.translate.get(`Résultat du test de fin de formation`).subscribe((value: string) => {
      this.metaSrv.setMetas({title: value});
    });
    this.result = await this.assessmentSrv.result();
    // Aucune tentative terminée : retour à l'écran d'accueil du test
    if (!this.result) {
      await this.router.navigate(['/', this.langSrcSrv.current.shortCode, 'assessment']);
      return;
    }
    this.loading = false;
  }

  async close() {
    await this.router.navigate(['/', this.langSrcSrv.current.shortCode, 'learning', 'dashboard']);
  }

  async retry() {
    await this.router.navigate(['/', this.langSrcSrv.current.shortCode, 'assessment', 'questions']);
  }

  answerGiven(question: any): string | null {
    return question.freeText || question.answerGiven || null;
  }

}
